export class PerfilTurma {
  constructor({
    id = null,
    nome = null,
    descricao = null,
    nivelDeEnsino = null,
    componenteCurricular = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.descricao = descricao;
    this.nivelDeEnsino = nivelDeEnsino;
    this.componenteCurricular = componenteCurricular;
  }
  static Build() {
    return new PerfilTurma({
      id: null,
      nome: null,
      descricao: null,
      nivelDeEnsino: null,
      componenteCurricular: null,
    });
  }
  format() {
    let ensino = this.nivelDeEnsino?.id ?? this.nivelDeEnsino;
    let componente = this.componenteCurricular?.id ?? this.componenteCurricular;
    return new PerfilTurma({
      ...this,
      nivelDeEnsino: ensino,
      componenteCurricular: componente,
    });
  }
}
